import { ApiError } from './throwifApiError'

/**
 * Type guard to check if an error matches a specific API error type.
 * Handles modern ApiError instances thrown by throwIfApiError.
 */
export const isApiErrorOfType = (error: unknown, type: string): error is ApiError<{ type: string; detail: object }> => {
  if (error instanceof ApiError) return error.type === type
  return false
}

const NOT_FOUND_TYPES = new Set(['NotFoundError', 'NotFoundErrorWithHintOrganisation'])

export const isNotFoundApiError = (error: unknown): error is ApiError<{ type: string; detail: object }> =>
  error instanceof ApiError && NOT_FOUND_TYPES.has(error.type)

export const isAuthApiError = (error: unknown): error is ApiError<{ type: string; detail: object }> =>
  isApiErrorOfType(error, 'UnauthorisedError')

export const isForbiddenApiError = (error: unknown): error is ApiError<{ type: string; detail: object }> =>
  isApiErrorOfType(error, 'ForbiddenError')

export const isTerminalApiError = (error: unknown): error is ApiError<{ type: string; detail: object }> =>
  isNotFoundApiError(error) || isForbiddenApiError(error)
